




























import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import configForm from "@components/common/form.vue";
import selectItem from "@components/common/formItem/selectItem.vue";
import textItem from "@components/common/formItem/textItem.vue";
import inputItem from "@components/common/formItem/inputItem.vue";
import linkItem from "@components/common/formItem/linkItem.vue";
import jump from "@lib/mixins/jump";
const taxFilingModule = namespace("vatTaxFiling");
const rootMapModule = namespace("app");
@Component({
  components: {
    configForm
    // taxFilingSuccess,
    // noTaxFiling
  },
  mixins: [jump]
})
export default class VatTaxFilingForm extends Vue {
  // @taxFilingModule.Getter("applyDetail")
  private applyDetail: any = {};

  @rootMapModule.Getter("country")
  private country: any;
  @rootMapModule.Getter("payType")
  private payType: any;
  //  费用
  private poundage: any = []
  // 协议
  private agreementChecked: boolean = false;
  // 按钮属性
  private btnDisabled: boolean = false;
  private loading: boolean = false;
  // 表单属性
  private formParam: any = {};
  private get formOption() {
    return {};
  }

  // 表单传进来的数据
  private get formData() {
    return _.cloneDeep(this.applyDetail);
  }

  private get formConfig() {
    return [
      {
        value: "nation",
        name: this.$t("vatTaxFiling.applyNation"),
        component: "textItem",
        componentVue: textItem,
        style: {},
        labelStyle: {
          width: "150px",
          height: "36px"
        },
        render: (data: any) => {
          return this.country[data.nation];
        }
      },
      {
        value: "storesLength",
        name: this.$t("vatTaxFiling.applyStore"),
        component: "textItem",
        componentVue: textItem,
        labelStyle: {
          width: "150px",
          height: "36px"
        },
        notParam: true,
        render: (data: any) => {
          return data.stores
            ? `${data.stores.length}${this.$t("vatTaxFiling.num")}`
            : `${this.$t("vatTaxFiling.none")}`;
        }
      },
      {
        value: "storeNames",
        name: this.$t('vatTaxFiling.applyStoreName'),
        labelStyle: {
          width: "150px",
          height: "36px"
        },
        component: "textItem",
        componentVue: textItem,
        notParam: true,
        render: (row: any) => {
          const stores: any = [];
          if (row.stores && row.stores.length) {
            row.stores.forEach((data: any) => {
              stores.push(data.name);
            });
            return _.join(stores, "、");
          } else {
            return `${this.$t("vatTaxFiling.none")}`;
          }
        }
      },
      {
        value: "agentName",
        name: this.$t('vatTaxFiling.applyAgent'),
        labelStyle: {
          width: "150px",
          height: "36px"
        },
        component: "textItem",
        componentVue: textItem,
        render: () => {
          return "PingPong";
        }
      },
      {
        value: "payType",
        name: this.$t("vatTaxFiling.payType"),
        component: "textItem",
        componentVue: textItem,
        style: {
        },
        labelStyle: {
          width: "150px",
          height: "36px"
        },
        notParam: true,
        render: (data: any) => {
          return this.payType[data.payType];
        }
      },
      {
        value: "amount",
        name: this.$t("vatTaxFiling.amount"),
        component: "textItem",
        componentVue: textItem,
        style: {
        },
        labelStyle: {
          width: "150px",
          height: "36px"
        },
        notParam: true,
        render: (row: any) => {
          // let str: any = "";
          // if(this.poundage.length) {
          //   str += `${this.$ppFilter.money(this.poundage[0].amount)} ${this.poundage[0].currency}`
          // }
          return `${this.$ppFilter.money(row.amount)} ${row.amountCurrency}`;
        }
      },
      {
        value: "payAmount",
        name: this.$t("vatTaxFiling.payAmount"),
        component: "textItem",
        componentVue: textItem,
        style: {
        },
        labelStyle: {
          width: "150px",
          height: "54px"
        },
        notParam: true,
        render: (row: any) => {
          // let str: any = "";
          // if(this.poundage.length) {
          //   str += `${this.$ppFilter.money(this.poundage[0].amount)} ${this.poundage[0].currency}`
          // }
          return `${this.$ppFilter.money(row.payAmount)} ${row.payAmountCurrency}`;
        }
      },
      // {
      //   value: "tradeId",
      //   name: "VAT税号",
      //   style: {
      //     "border-top": "1px solid rgba(0,0,0,0.08)",
      //     "padding-top": "24px"
      //   },
      //   labelStyle: {
      //     width: "150px",
      //     height: "36px"
      //   },
      //   component: "textItem",
      //   componentVue: textItem
      // },
      {
        value: "menu",
        name: this.$t('vatTaxFiling.applyList'),
        style: {
          "border-top": "1px solid rgba(0,0,0,0.08)",
          "padding-top": "24px"
        },
        labelStyle: {
          width: "150px",
          height: "36px"
        },
        component: "linkItem",
        componentVue: linkItem,
        click: (data: any) => {
          this.$href({
            fullPath: `#/agreement/vat-taxFiling`,
            open: true
          });
        },
        render: (data: any) => {
          return this.$t('index.toDetail');
        }
      }
      // {
      //   value: "link",
      //   name: "注册协议",
      //   labelStyle: {
      //     width: "150px",
      //     height: "36px"
      //   },
      //   component: "linkItem",
      //   componentVue: linkItem,
      //   click: (data: any) => {
      //     console.log(data);
      //   },
      //   render: (data: any) => {
      //     return "协议";
      //   }
      // }
    ];
  }
  // 申请按钮
  private taxFiling() {
    console.log(111);
  }
  private async mounted() {
    // await await this.$block.dispatch("vatRegister/getAppliesDetail", {
    //   params: {
    //     taxFilingNo: this.$route.
    //   }
    // });
    const result = await this.$block.dispatch("vatTaxFiling/getDetail", {
      params: {
        applyNo: this.$route.params.applyNo
      }
    });
    this.applyDetail = result;
    // const resultPoundage = await this.$block.dispatch(
    //   "vatTaxFiling/getPoundage",
    //   {
    //     params: {
    //       nation: this.applyDetail.nation,
    //       payType: this.applyDetail.payType,
    //       currency: 'EUR',
    //       applyType: "filing"
    //     }
    //   }
    // );
    // this.poundage = resultPoundage;
  }
}
